import { useApp } from '../state/AppContext';
import Icon from '../lib/Icon';
import { buildSidebar, PARENT } from '../lib/roles';
import type { ScreenKey } from '../lib/types';

export default function Sidebar({ current, open }: { current: ScreenKey; open?: boolean }) {
  const { state, go } = useApp();
  const sections = buildSidebar(state.role, state.lang);
  const activeKey = PARENT[current] ?? current;

  return (
    <div data-tour="sidebar" className={'app-sidebar' + (open ? ' open' : '')} style={{ width: 240, flex: 'none', background: 'var(--color-white)', borderRight: '1px solid var(--color-border)', overflowY: 'auto', padding: '16px 12px' }}>
      {sections.map((sec, si) => (
        <div key={si} style={{ marginBottom: 18 }}>
          <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: '.07em', textTransform: 'uppercase', color: 'var(--color-fg-3)', padding: '0 10px 8px' }}>{sec.label}</div>
          {sec.items.map((it) => {
            const active = activeKey === it.key;
            return (
              <button
                key={it.key}
                data-tour={`nav-${it.key}`}
                className="hv-ink"
                onClick={() => go(it.key)}
                style={{ position: 'relative', width: '100%', display: 'flex', alignItems: 'center', gap: 11, padding: '10px 12px', borderRadius: 'var(--radius-sm)', textAlign: 'left', marginBottom: 2, background: active ? 'var(--color-blue-100)' : 'transparent', fontWeight: active ? 700 : 500, color: active ? 'var(--color-blue-700)' : 'var(--color-fg-2)' }}
              >
                <span style={{ position: 'absolute', left: 0, top: 6, bottom: 6, width: 3, borderRadius: '0 3px 3px 0', background: active ? 'var(--color-blue)' : 'transparent' }} />
                <Icon name={it.icon} style={{ fontSize: 16, flex: 'none' }} />
                <span style={{ fontSize: 13, flex: 1 }}>{it.label}</span>
                {it.badge && (
                  <span style={{ minWidth: 18, height: 18, padding: '0 5px', background: 'var(--color-error)', color: '#fff', borderRadius: 999, fontSize: 11, fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{it.badge}</span>
                )}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
